import { AppDispatch } from '@/store/store';
import { fetchInitialChatState } from '@/store/thunks/FetchThreads';
import { getChatAPI } from '@/api/ChatApi';
import { getThreadFromApi, Thread } from '@/models/Thread';
import { setCurrentThread } from '@/store/reducers/UIState';

export async function startNewThreadFromMessage(
  messageId: string,
  dispatch: AppDispatch,
  eventId?: string,
): Promise<Thread | null> {
  const chatApi = getChatAPI();
  try {
    // create a new thread with the referrer message
    const { data } = await chatApi.forkThreadFromMessage(messageId, eventId);

    if (!data) {
      return null;
    }

    const thread: Thread = getThreadFromApi(data.thread); // convert resp from api to typed Thread
    dispatch(setCurrentThread(thread));
    dispatch(fetchInitialChatState());
    return thread;
  } catch (e) {
    console.log('Error starting new thread from message', e);
    return null;
  }
}
